var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3145 12.1718C22.1319 11.9268 17.7801 6.17285 12.2221 6.17285C6.66414 6.17285 2.31218 11.9268 2.12973 12.1716C1.95676 12.404 1.95676 12.7192 2.12973 12.9517C2.31218 13.1967 6.66414 18.9506 12.2221 18.9506C17.7801 18.9506 22.1319 13.1966 22.3145 12.9519C22.4877 12.7195 22.4877 12.404 22.3145 12.1718ZM12.2221 17.6288C8.12808 17.6288 4.5822 13.8098 3.53254 12.5613C4.58084 11.3117 8.1193 7.49468 12.2221 7.49468C16.316 7.49468 19.8616 11.313 20.9117 12.5622C19.8634 13.8117 16.325 17.6288 12.2221 17.6288Z",
    fill: "#989FB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 8.5957C9.99239 8.5957 8.17822 10.3747 8.17822 12.5612C8.17822 14.7478 9.99239 16.5268 12.2222 16.5268C14.452 16.5268 16.2662 14.7478 16.2662 12.5612C16.2662 10.3747 14.452 8.5957 12.2222 8.5957ZM12.2222 15.2049C10.7356 15.2049 9.52624 14.019 9.52624 12.5612C9.52624 11.1035 10.7356 9.91757 12.2222 9.91757C13.7088 9.91757 14.9182 11.1035 14.9182 12.5612C14.9182 14.019 13.7088 15.2049 12.2222 15.2049Z",
    fill: "#989FB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.f908d82c36ddc02a4f914e66f0e62752.svg";
export { ForwardRef as ReactComponent };